module.exports = __webpack_public_path__ + "static/media/pyjumper.fb24b870.png";